import { HomeComponent } from '@/components/home';

export default function Home() {
  return <HomeComponent />;
}
